export const BULK_UPLOAD_HEADERS = [
  'Offer name',
  'Offer link',
  'Offer entry domain name',
  'Offer redirect domain name',
  'Use existing Tsource',
  'Existing Tsource name',
  'New Tsource name',
  'New Tsource network',
  'New Tsource connected DSP',
  'New Tsource XML field',
  'New Tsource blockAnon',
  'New Tsource blockDataCenter',
  'New Tsource blockExt',
  'New Tsource blockIpGeneral',
  'New Tsource blockIpDdos',
  'New Tsource blockIpRecon',
  'New Tsource blockLocation',
  'New Tsource ipThrottle',
  'New Tsource fallbackLink',
  'New Tsource isPassback',
  'New Tsource passbackUrl',
  'New Tsource params',
  'Use existing cmp',
  'Existing cmp name',
  'New cmp name',
  'New cmp entry domain name',
  'New cmp offer group key',
  'New cmp blockAnon',
  'New cmp blockDataCenter',
  'New cmp blockExt',
  'New cmp blockIpGeneral',
  'New cmp blockIpDdos',
  'New cmp blockIpRecon',
  'New cmp blockLocation',
  'New cmp ipThrottle',
  'New cmp fallbackLink',
  'New cmp isPassback',
  'New cmp passbackUrl',
  'Cmp merchant id',
  'Cmp merchant name',
  'Cmp merchant url',
  'Cmp affiliate url',
  'Cmp click cap',
  'Cmp commission',
  'Cmp geo',
  'Cmp device',
];

export const BULK_UPLOAD_SAMPLE_DATA = [
  [
    'My offer',
    'https://google.com/?pubid={x1}&click={clkid}',
    'rushflip',
    'onlydrops_1',
    'true',
    'my_dummy_source',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'true',
    'Test cf777',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '190195',
    'My merchant',
    'https://merchant.com',
    '{offer_redirect_url}?x1={x1}&clkid={clkid}',
    '100',
    '0.5',
    'US',
  ],
  [
    'Another one',
    'https://google.com/?pubid={x1}&click={clkid}',
    'rushflip',
    'onlydrops_1',
    'false',
    '',
    'new source name',
    'default',
    'choose between "rapid" or "dsp24" or leave empty',
    '',
    'true',
    'true',
    'true',
    'true',
    'true',
    'true',
    'whitelist-US-ALL-ALL,blacklist-US-CA-ALL',
    '1:2:3',
    'https://fallback.com',
    'true',
    'useFbParameter',
    'x1-none-7-,clkid-alphanumeric-7-NGSP',
    'false',
    '',
    'My test campaign',
    'rushflip',
    'couponfollow_key',
    'true',
    'true',
    'true',
    'true',
    'true',
    'true',
    'whitelist-US-ALL-ALL,blacklist-US-CA-ALL',
    '1:2:3',
    'https://fallback.com',
    'true',
    'useFbParameter',
    '190195',
    'My merchant',
    'https://merchant.com',
    '{offer_redirect_url}?x1={x1}&clkid={clkid}',
    '100',
    '0.6',
    'US',
  ],
];
